import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  index: number;
  pack: Pack;
}

/**
 * `PackOptionCard` component emits.
 */
export type Emits = (event: 'selected', key: string) => void;


import { ref, computed } from 'vue';

import { useStore } from '@store';

import DisplayPrice from '@components/Display/DisplayPrice.vue';
import Icon from '@components/Icon.vue';

import { faCheckCircle } from '@icons/regular/faCheckCircle';
import { faTimes } from '@icons/regular/faTimes';

declare module 'vue/types/vue' {
  export interface Vue {
    PackOptionCard: ComponentWithProps<Props>;
  }
}

/**
 * Option card pack feature info.
 */
export interface Feature {
  key: string;
  name: string;
  isIncluded: boolean;
}

/**
 * Option card pack info.
 */
export interface Pack {
  key: string;
  title: string;
  description: string;
  price: string | number;
  badge?: string;
  features: Feature[];
  oneTimePurchase?: boolean;
  personalUseOnly?: boolean;
}

const __default__ = { name: 'PackOptionCard' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    index: null,
    pack: null
  },
  emits: ["selected"],
  setup(__props: any, { emit }: { emit: ((event: 'selected', key: string) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  index: number;
  pack: Pack;
};

/**
 * `PackOptionCard` component properties.
 */




const store = useStore();

const cartHasItem = store.getters['cart/hasItem'];

const entering = ref(false);

/** `true` if the option card's product is in the cart, otherwise `false`. */
const selected = computed(() => cartHasItem(props.pack.key));

/**
 * Listener to be called when the option card is selected.
 */
function onAfterEnter() {
  entering.value = false;
}

return { __sfc: true,props, emit, store, cartHasItem, entering, selected, onAfterEnter, DisplayPrice, Icon, faCheckCircle, faTimes }
}

})